import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {queryClient} from 'App';

const initialState = {
  theme: 'system' as 'system' | 'light' | 'dark',
  authToken: '',
  impersonating: false,
  urlAfterAuth: '',
  countryCode: {code: 'MY', staleTime: null as null | Date},
};

type usePersistentStoreType = typeof initialState & {
  toggleTheme: () => void;
  setTheme: (theme: 'light' | 'dark') => void;
  setAuthToken: (authToken: string) => void;
  setImpersonating: (impersonating: boolean) => void;
  setUrlAfterAuth: (urlAfterAuth: string) => void;
  setCountryCode: (countryCode: {code: string; staleTime: null | Date}) => void;
  reset: () => void;
};

const usePersistentStore = create<usePersistentStoreType>()(
  persist(
    (set, get) => ({
      ...initialState,
      toggleTheme: () => {
        const theme = get().theme;
        set({theme: theme === 'light' ? 'dark' : 'light'});
      },
      setTheme: theme => set({theme}),
      setAuthToken: authToken => set({authToken}),
      setImpersonating: impersonating => set({impersonating}),
      setUrlAfterAuth: urlAfterAuth => set({urlAfterAuth}),
      setCountryCode: countryCode => set({countryCode}),
      reset: () => {
        queryClient.clear();
        set(initialState);
      },
    }),
    {name: 'dasar-admin.storage'},
  ),
);

export default usePersistentStore;
